export default {
    // @Device Identity
    setDeviceIdentity(state, value) {
        state.deviceIdentity = value
    }
}